import { computed } from 'vue';

export default {
  data() {
    return {
      sidebarElementQuery: undefined,
      sidebarElement: {},
    };
  },
  provide() {
    return {
      selectDropdownParent: computed(() => this.sidebarElement),
    };
  },
  mounted() {
    // Designed so that it works with AppSidebar.vue but sidebarElementQuery can be used to override it
    this.sidebarElement = $(this.sidebarElementQuery || '.vue-sidebar-content');
  },
};
